export const isErrorWithName = (error: unknown, name: string): boolean => {
  return (
    typeof error === "object" &&
    error !== null &&
    "name" in error &&
    typeof (error as { name?: unknown }).name === "string" &&
    (error as { name: string }).name === name
  );
};
